import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    common: {
      home: 'Home',
      library: 'Library',
      favorites: 'Favorites',
      settings: 'Settings',
      login: 'Login',
      logout: 'Logout',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      name: 'Name',
      phone: 'Phone',
      city: 'City',
      businessType: 'Business Type',
      identifier: 'Identifier',
      play: 'Play',
      pause: 'Pause',
      next: 'Next',
      previous: 'Previous',
      addToFavorites: 'Add to Favorites',
      removeFromFavorites: 'Remove from Favorites',
    },
    home: {
      welcomeMessage: 'Welcome to Music TMM',
      playlists: 'Playlists',
      moods: 'Moods',
      styles: 'Styles',
      businesses: 'Businesses',
      daytimes: 'Day Times',
    },
    playlist: {
      songs: 'Songs',
      duration: 'Duration',
      updatedAt: 'Updated',
      playAll: 'Play All',
    },
  },
  fr: {
    common: {
      home: 'Accueil',
      library: 'Bibliothèque',
      favorites: 'Favoris',
      settings: 'Paramètres',
      login: 'Connexion',
      logout: 'Déconnexion',
      register: 'S\'inscrire',
      email: 'Email',
      password: 'Mot de passe',
      name: 'Nom',
      phone: 'Téléphone',
      city: 'Ville',
      businessType: 'Type d\'entreprise',
      identifier: 'Identifiant',
      play: 'Jouer',
      pause: 'Pause',
      next: 'Suivant',
      previous: 'Précédent',
      addToFavorites: 'Ajouter aux favoris',
      removeFromFavorites: 'Retirer des favoris',
    },
    home: {
      welcomeMessage: 'Bienvenue sur Music TMM',
      playlists: 'Listes de lecture',
      moods: 'Ambiances',
      styles: 'Styles',
      businesses: 'Entreprises',
      daytimes: 'Moments de la journée',
    },
    playlist: {
      songs: 'Chansons',
      duration: 'Durée',
      updatedAt: 'Mis à jour',
      playAll: 'Tout jouer',
    },
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
